import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc264a28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table__header q-mb-sm" }
const _hoisted_2 = {
  key: 0,
  class: "text-h4 no-wrap q-mr-md"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Показать все ")
const _hoisted_4 = {
  key: 3,
  class: "table__search-field"
}
const _hoisted_5 = {
  key: 5,
  class: "table__export"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("экспорт в эксель")
const _hoisted_7 = { class: "sticky-head" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["data-id"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "flex justify-end"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "resizable-table-cell-content" }
const _hoisted_14 = ["colspan"]
const _hoisted_15 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_16 = {
  key: 0,
  class: "table__footer"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pagination-description" }, "Показывать по:", -1))

import {
  PropType,
  computed,
  reactive,
  onBeforeMount,
  ref,
  onMounted,
  onBeforeUnmount,
  onUnmounted,
  watchEffect,
  nextTick,
  watch,
  Ref,
  ComponentPublicInstance,
} from 'vue';
import { actionHandler } from '~actions/actionHandler';
import SearchSelect from '@/components/SearchSelect.vue';
import { getSumByField, sumFieldValues } from '@/utils/getSumByField';
import { LSKeys, MAX_UNPAGINATED_TABLE_SIZE } from '@/constants';
import { useMainStore } from '@/store';
import resizeColumns from '@/utils/directives';
import {
  TableColumn,
  TableRow,
  TableStructure,
  Filter,
  Action,
  ITable,
  SelectionType,
  FilterType,
  DragAndDropHandler,
} from './types';
import ColumnFilter from './ColumnFilter.vue';
import ExpandableContent from './ExpandableContent.vue';
import PinIconButton from './PinIconButton.vue';
import { convertDataForSorting } from './helpers';
import { defaultStructure } from './defaultStructure';
import {
  defineCellProps,
  defineComponentName,
  findEventTargetParent,
} from './composables';

enum SortDirection {
  asc = 1,
  desc = -1,
  nd = 0,
}

type HookCallback = (item: TableRow) => TableRow;

type Pin = {
  [key: string]: boolean;
};

type Pins = {
  [key: string]: Pin;
};

type Pinnable = {
  name_column: string,
  colname: string,
  pinned: boolean,
};
type Cell = {
  props?: {
    text?: string;
    value?: string | number;
  };
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TableComponent',
  props: {
  tableId: {
    type: String as PropType<string>,
    default: () => '',
  },
  table: {
    type: Object as PropType<ITable>,
    default: () => {},
  },
  structure: {
    type: Object as PropType<TableStructure>,
    default: () => defaultStructure,
  },
  useItems: {
    type: Array as PropType<HookCallback[]>,
    default: () => [],
  },
  useTrust: {
    type: Boolean as PropType<boolean>,
    default: () => true,
  },
  selected: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
},
  emits: ['refresh', 'selection'],
  setup(__props, { emit }) {

const props = __props

const paginationOptions: number[] = [5, 10, 20, 50];



const vResizeColumns = resizeColumns;

const setTrustedStructure = computed<TableStructure>(() => {
  const structure = props.table.structure?.trusted_struct && props.useTrust
    ? props.table.structure
    : props.structure;
  return {
    ...structure,
    pagination:
      props.table?.structure?.pagination || props.table?.data?.length > MAX_UNPAGINATED_TABLE_SIZE,
  };
});

const trustedStructure = reactive(setTrustedStructure.value);



const emptyState = computed(() => (props.table.data ? Boolean(!props.table.data.length) : true));
const emptyStateText = ref(trustedStructure?.empty_state || 'Пустая таблица');

const data = reactive({
  items: props.table.data,
  event: trustedStructure.name_event,
  field_id: trustedStructure?.field_id,
  columns: trustedStructure?.columns.map((col, i) => ({
    ...col,
    name_column: col.name_column || Date.now().toString(),
    columnId: i,
  })),
  direction: SortDirection.nd,
  selectedItems: [] as number[],
  selectAll: false,
  isLoading: false,
  filters: [] as Filter[],
  currentPage: 1,
  expandedRow: null as number | null,
  itemsPerPage: 20,
  search: '',
  expandedJsonCell: {
    col: null as number | null,
    row: null as number | null,
  },
});

const debounce = (func: any, delay: number) => {
  let timeoutId: number;
  return (...args: any) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
};

if (props.useItems.length && data.items) {
  props.useItems.forEach((fn) => {
    data.items = data.items.map(fn);
  });
}

const generateIds = () => {
  if (!trustedStructure?.field_id && data.items) {
    data.field_id = 'id';
    data.items = data.items.map((item, index) => ({
      ...item,
      id: index,
    }));
  }
};

const items = computed(() => data.items);
const title = ref(trustedStructure.title);
const markupTable = ref<ComponentPublicInstance | null>(null);
const tableWrapper = ref(null);
const markupTableWidth = ref();
const prevTableWrapperWidth = ref();
let resizeWrapperObserver: ResizeObserver | null = null;
const wrapperWidth: Ref<number> = ref(0);
const columnsRefs = ref<HTMLTableCellElement[]>([]);

const visibleColumns = computed(
  () => data.columns.filter((el) => el.visible && !el.hidden),
);

const columnsWithPins = computed<Pinnable[]>(() => data.columns
  .filter((el: TableColumn) => ('pinned' in el) && el.visible)
  .map((el) => ({
    name_column: el.name_column,
    colname: el.colname,
    pinned: el.pinned ?? false,
  })));

const hiddenColumns = computed(() => data.columns.filter(
  (el) => el.hidden && el.visible,
));

const renderedColumns = () => {
  const result = data.columns
    .filter((col) => col.visible && !col.hidden)
    .sort((a, b) => {
      if (a?.pinned === undefined) return -1;
      if (b?.pinned === undefined) return 1;
      return Number(b.pinned) - Number(a.pinned);
    });
  return result;
};

const unhideAllColumns = () => {
  data.columns = data.columns.map((col) => ({ ...col, hidden: false }));
};

const addWidthsToColumns = (direction = 'left') => {
  if (direction === 'left') {
    data.columns = data.columns.map((col, i) => {
      const el = columnsRefs.value.find(
        (renderedColumn) => Number(renderedColumn.dataset.id) === i,
      );
      return {
        ...col,
        renderedWidth: el ? el.clientWidth : 0,
      };
    });
  } else {
    data.columns = data.columns.map((col, i) => ({
      ...col,
      renderedWidth: getSumByField(renderedColumns(), 'renderedWidth') / renderedColumns().length + 1,
    }));
  }
};

const tableSizeComparison = (direction: string): boolean => {
  if (!markupTable.value || !renderedColumns().length) return false;

  const outerTableElement = markupTable.value['$el'] as HTMLElement;
  const checkboxesWidth = trustedStructure.selection ? 60 : 0;
  const outerWidth = outerTableElement.getBoundingClientRect().width - checkboxesWidth;
  const innerWidth = getSumByField(renderedColumns(), 'renderedWidth');
  return direction === 'left'
    ? outerWidth < innerWidth
    : outerWidth - 50 > innerWidth;
};

const autoCalculateColumns = (direction: 'left' | 'right' = 'left') => {
  const isTableWiderThanWindow = tableSizeComparison(direction);
  if (isTableWiderThanWindow) {
    if (direction === 'left') {
      const lastColumn = renderedColumns().reverse().find(
        (column: TableColumn) => !(column.pinned === true || !('pinned' in column)),
      );
      if (lastColumn) {
        const columnToHide = data.columns.find(
          (col) => col.name_column === lastColumn.name_column,
        );
        if (columnToHide) {
          columnToHide.hidden = true;
          trustedStructure.expandable_rows = true;
          autoCalculateColumns(direction);
        }
      }
    } else {
      const firstUnpinnedHiddenColumnIndex = data.columns.findIndex(
        (col) => !col.pinned && col.hidden && col.visible,
      );
      if (firstUnpinnedHiddenColumnIndex !== -1) {
        data.columns[firstUnpinnedHiddenColumnIndex].hidden = false;
        autoCalculateColumns(direction);
      }
    }
  } else if (!isTableWiderThanWindow && direction === 'right') {
    setTimeout(() => {
      addWidthsToColumns();
      autoCalculateColumns();
    }, 100);
  }
};

const updateWidth = debounce(() => {
  if (markupTable.value && tableWrapper.value) {
    const outerTableElement = markupTable.value['$el'] as HTMLElement;
    markupTableWidth.value = outerTableElement.getBoundingClientRect().width;
    const direction = prevTableWrapperWidth.value > markupTableWidth.value ? 'left' : 'right';
    if (direction === 'left' && renderedColumns().length === 1) return;
    addWidthsToColumns(direction);
    autoCalculateColumns(direction);
    prevTableWrapperWidth.value = markupTableWidth.value;
  }
}, 100);

const getSavedPins = () => {
  try {
    const savedPins = localStorage.getItem(LSKeys.pins);
    if (!savedPins || !data.event) {
      return;
    }
    const currentTablePinsData = JSON.parse(savedPins)[data.event];
    if (currentTablePinsData) {
      Object.keys(currentTablePinsData).forEach((key) => {
        const column = visibleColumns.value.find(
          (col: TableColumn) => col.name_column === key,
        ) as TableColumn;
        if (column) {
          column.pinned = currentTablePinsData[key];
        }
      });
    }
  } catch (error) {
    console.log(error);
  }
};

const setSavedPins = (key: string, value: boolean) => {
  if (!data.event) {
    return;
  }
  try {
    const savedPins = localStorage.getItem(LSKeys.pins);
    if (savedPins) {
      const pins = JSON.parse(savedPins);
      if (!pins[data.event]) {
        pins[data.event] = {};
      }
      pins[data.event][key] = value;
      localStorage.setItem(LSKeys.pins, JSON.stringify(pins));
    } else {
      const newPins = {} as Pins;
      newPins[data.event] = {};
      newPins[data.event][key] = value;
      localStorage.setItem(LSKeys.pins, JSON.stringify(newPins));
    }
  } catch (error) {
    console.log(error);
  }
};

const togglePin = (name: string) => {
  const column = data.columns.find((col) => col.name_column === name);
  if (column) {
    column.pinned = !column.pinned;
    const d = column.pinned ? 'right' : 'left';
    column.hidden = tableSizeComparison(d) && !column.pinned;
    // data.columns[ind].hidden = !data.columns[ind].pinned;
    // unhideAllColumns();
    // const d = data.columns[ind].pinned ? 'right' : 'left';
    addWidthsToColumns();
    autoCalculateColumns();
    setSavedPins(name, column.pinned);
  }
};

onBeforeMount(() => {
  generateIds();
  getSavedPins();
});

watch(
  () => wrapperWidth.value,
  () => {
    updateWidth();
  },
);

onMounted(() => {
  nextTick(() => {
    resizeWrapperObserver = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      entries.forEach((entry) => {
        wrapperWidth.value = entry.contentRect.width;
      });
    });
    if (tableWrapper.value) {
      resizeWrapperObserver.observe(tableWrapper.value);
    }
  });
  if (markupTable.value) {
    const element = markupTable.value['$el'] as HTMLElement;
    prevTableWrapperWidth.value = element.clientWidth;
  }

  // unhideAllColumns();
  addWidthsToColumns();
  autoCalculateColumns();
});
onUnmounted(() => {
  if (markupTable.value) {
    const outerTableElement = markupTable.value['$el'] as HTMLElement;
    outerTableElement.removeEventListener('resize', updateWidth);
  }
});
onBeforeUnmount(() => {
  if (resizeWrapperObserver) {
    resizeWrapperObserver.disconnect();
  }
  emit('selection', []);
});

const showTableHeader = computed(() => data.columns.some((col) => col.colname));

const expandableAreaSize = computed(() => {
  const coeff = trustedStructure?.selection ? 1 : 0;
  return visibleColumns.value.length + coeff;
});

const filteredItems = computed((): TableRow[] => {
  let filtered = items.value;
  data.filters.forEach((el) => {
    filtered = filtered.filter((item) => {
      if (item[el.colName]) {
        if (typeof el.value === 'string') {
          return el.value === item[el.colName];
        }
        return el.value?.includes(item[el.colName].toString());
      }
      return false;
    });
  });

  if (
    (trustedStructure?.search && data.search.length > 2)
    || (trustedStructure.searchselect && trustedStructure.searchselect.filter)
  ) {
    const { search } = trustedStructure;
    if (search) {
      if (typeof search === 'string') {
        return filtered
          .filter((item) => item[search]
            .toString().toLowerCase().includes(data.search.toLowerCase()));
      }
      if (typeof search === 'object') {
        return filtered
          .filter((item) => search
            .some((key) => (item[key]
              ? item[key].toString().toLowerCase().includes(data.search.toLowerCase())
              : item)));
      }
    }
  }
  return filtered;
});

const getCellText = (cell: Cell) => {
  if (typeof cell === 'string') return cell;
  if (cell.props?.text) return cell.props.text;
  if (cell.props?.value) return String(cell.props.value);
  return '';
};

const tooltip = ref({
  visible: false,
  x: 0,
  y: 0,
  content: '',
});

const showTooltip = (event: MouseEvent, cell: Cell): void => {
  const element = event.currentTarget as HTMLElement;
  if (element.scrollWidth > element.clientWidth && cell !== undefined) {
    tooltip.value = {
      visible: true,
      x: event.clientX,
      y: event.clientY + 20,
      content: getCellText(cell),
    };
  }
};

const hideTooltip = () => {
  tooltip.value.visible = false;
};

// const searchFieldsForDisplay = computed<string>(() => {
//   const { search } = trustedStructure;
//   if (!search) {
//     return '';
//   }
//   if (typeof search === 'string') {
//     return data.columns
//       .find((col) => col.colname === search)
//   }
// });

const showSearchSelect = computed(
  () => trustedStructure.searchselect
    && Object.keys(trustedStructure.searchselect.action).length
    && trustedStructure.searchselect.field,
);

const sort = (column: TableColumn) => {
  switch (data.direction) {
    case SortDirection.nd:
      data.direction = SortDirection.asc;
      break;
    case SortDirection.asc:
      data.direction = SortDirection.desc;
      break;
    case SortDirection.desc:
      data.direction = SortDirection.asc;
      break;
    default:
      data.direction = SortDirection.nd;
  }

  items.value.sort((a, b) => {
    let result = 0;

    const aData: string | number = convertDataForSorting(a[column.name_column]);
    const bData: string | number = convertDataForSorting(b[column.name_column]);
    if (aData > bData) {
      result = 1;
    } else if (bData > aData) {
      result = -1;
    }
    return result * data.direction;
  });
  data.columns = data.columns.map((col) => ({
    ...col,
    sorted: undefined,
  }));
  const ind = data.columns.findIndex((i: TableColumn) => i.name_column === column.name_column);
  if (ind > -1) data.columns[ind].sorted = SortDirection[data.direction];
};

const setColumnValues = (colName: string): string[] | undefined => {
  const values: string[] = [];
  data.items.forEach((item) => {
    if (!values.includes(item[colName])) {
      values.push(item[colName]);
    }
  });
  return values;
};

const setColumnFilter = (filter: Filter) => {
  const existedFilterIndex = data.filters.findIndex((el) => el.colName === filter.colName);
  if (existedFilterIndex === -1) {
    data.filters.push(filter);
    return;
  }
  if (!filter.value) {
    data.filters.splice(existedFilterIndex, 1);
    return;
  }
  const existedFilter = data.filters[existedFilterIndex];
  if (existedFilter && existedFilter.value) {
    if (filter.type === FilterType.MULTIPLE) {
      existedFilter.value = Array.from(new Set(existedFilter.value.concat(filter.value)));
    } else {
      existedFilter.value = filter.value;
    }
  }
};

const removeColumnFilter = (filterToRemove: Filter) => {
  const index = data.filters.findIndex(
    (filter) => filter.colName === filterToRemove.colName,
  );

  if (index !== -1) {
    data.filters.splice(index, 1);
  }
};

const handleSelect = (val: number[]) => {
  const type = trustedStructure.selection;
  if (!type) {
    return;
  }
  if (type === SelectionType.SINGLE) {
    data.selectedItems = [val[val.length - 1]];
  }
  if (type === SelectionType.MULTIPLE) {
    data.selectedItems = val;
  }
  emit('selection', data.selectedItems);
};

const handleSelectAll = (val: boolean) => {
  if (trustedStructure?.selection !== SelectionType.MULTIPLE) {
    return;
  }
  if (!val) {
    data.selectedItems = [];
    return;
  }
  data.selectedItems = items.value.map((item) => item[data.field_id]);
  emit('selection', data.selectedItems);
};

const handleExternalSelect = (selection: Array<number>) => {
  data.selectedItems = selection;
  if (props.selected.length) {
    const filter: Filter = {
      colName: data.field_id,
      value: selection.map((el) => el.toString()),
      type: FilterType.SINGLE,
    };
    setColumnFilter(filter);
  }
};

watchEffect(() => {
  data.items = props.table.data;
});

watch(
  props,
  () => {
    handleExternalSelect(props.selected);
  },
  { deep: true },
);

const paginatedItems = computed(() => {
  const { pagination } = trustedStructure;
  if (!pagination) {
    return filteredItems.value;
  }
  return filteredItems.value.slice(
    (data.currentPage - 1) * data.itemsPerPage,
    data.currentPage * data.itemsPerPage,
  );
});

const maxPages = computed(() => Math.ceil(filteredItems.value.length / data.itemsPerPage));

const paginate = (pageNumber: number) => {
  data.currentPage = pageNumber;
};

const expandRow = (row: TableRow) => {
  if (!trustedStructure?.expandable_rows
    || (!hiddenColumns.value.length && !trustedStructure?.expandable_contents)
  ) {
    return;
  }
  const id = row[data.field_id];
  if (data.expandedRow === id) {
    data.expandedRow = null;
    return;
  }
  data.expandedRow = id;
};

const jsonCellHandler = (col: number, row: number) => {
  const jsonCell = data.expandedJsonCell;
  if (jsonCell.col === col && jsonCell.row === row) {
    data.expandedJsonCell = { col: null, row: null };
    return;
  }
  data.expandedJsonCell = { col, row };
};

const exportModal = () => {
  const params = {
    columns: visibleColumns.value,
    items: items.value,
  };
  const action: Action = {
    name: 'ExportToExcelModal',
    type: 'modal',
    customParam: JSON.stringify(params),
  };
  actionHandler(action);
};

const onRefresh = () => {
  emit('refresh');
};

const select = async (val: any) => {
  if (trustedStructure.searchselect) {
    const action = {
      ...trustedStructure.searchselect.action,
      customParam: val,
    };
    const result = await actionHandler(action);
  }
};

const setSearchString = ({ needle, field }: { needle: string; field: string }) => {
  data.search = needle;
  trustedStructure.search = field;
};

const onBlur = () => {
  data.search = '';
  trustedStructure.search = '';
};

const clearAllFilters = () => {
  // data.filters = [];
  handleExternalSelect([]);
  data.filters = [];
};

const onDragStart = (event: DragEvent, row: TableRow) => {
  if (!trustedStructure.draggable) {
    return;
  }
  event.dataTransfer?.setData('dndData', JSON.stringify(row));
};

const onDragOver = (event: DragEvent) => {
  findEventTargetParent(event, 'tr')?.classList.add('row_highlighted');
};

const onDragLeave = (event: DragEvent) => {
  findEventTargetParent(event, 'tr')?.classList.remove('row_highlighted');
};

const onDrop = (event: DragEvent, row: TableRow) => {
  if (!trustedStructure.draggable) {
    return;
  }
  const dndData = event.dataTransfer?.getData('dndData');
  if (!dndData) {
    return;
  }
  const draggingRow = JSON.parse(dndData);
  const action = trustedStructure.draggable;
  const actionParams = {
    [action.customParam?.source_key]: draggingRow[trustedStructure.field_id],
    [action.customParam?.recipient_key]: row[trustedStructure.field_id],
  };
  if (draggingRow[trustedStructure.field_id] === row[trustedStructure.field_id]) {
    return;
  }
  actionHandler({ ...action }, { ...actionParams });
};

return (_ctx: any,_cache: any) => {
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_markup_table = _resolveComponent("q-markup-table")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_pagination = _resolveComponent("q-pagination")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (trustedStructure.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(title.value), 1))
        : _createCommentVNode("", true),
      (_unref(columnsWithPins).length)
        ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
            key: 1,
            dense: "",
            class: "q-px-sm q-mr-md",
            color: "accent",
            size: "sm",
            label: "",
            icon: "push_pin",
            style: {"height":"26px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_list, { dense: "" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columnsWithPins), (column) => {
                    return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                      clickable: "",
                      key: column.name_column
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_checkbox, {
                              modelValue: column.pinned,
                              "onUpdate:modelValue": ($event: any) => ((column.pinned) = $event),
                              onClick: _withModifiers(($event: any) => (togglePin(column.name_column)), ["stop"])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(column.colname), 1)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)), [
                      [_directive_close_popup]
                    ])
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (data.filters.length)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 2,
            icon: "filter_alt_off",
            color: "accent",
            "text-color": "white",
            size: "sm",
            onClick: clearAllFilters
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_space),
      (trustedStructure.search && !_unref(showSearchSelect))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: data.search,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.search) = $event)),
              label: "Поиск"
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (_unref(showSearchSelect))
        ? (_openBlock(), _createBlock(SearchSelect, {
            key: 4,
            id: trustedStructure.searchselect?.id,
            field: trustedStructure.searchselect?.field,
            label: trustedStructure.searchselect?.label,
            filter: trustedStructure.searchselect?.filter,
            searchFromBackend: trustedStructure.searchselect?.search_from_backend,
            options: data.items,
            onSelect: select,
            onFilter: setSearchString,
            onBlur: onBlur
          }, null, 8, ["id", "field", "label", "filter", "searchFromBackend", "options"]))
        : _createCommentVNode("", true),
      (trustedStructure.export)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_q_btn, {
              flat: "",
              color: "accent",
              icon: "download",
              onClick: exportModal
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "table__wrapper",
      ref_key: "tableWrapper",
      ref: tableWrapper
    }, [
      _withDirectives((_openBlock(), _createBlock(_component_q_markup_table, {
        dense: "",
        class: _normalizeClass({ 'q-markup-table_with-empty-state': _unref(emptyState) }),
        ref_key: "markupTable",
        ref: markupTable,
        separator: "vertical"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("thead", _hoisted_7, [
            _createVNode(_component_q_tr, null, {
              default: _withCtx(() => [
                (trustedStructure.selection)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_8, [
                      (trustedStructure.selection === _unref(SelectionType).MULTIPLE)
                        ? (_openBlock(), _createBlock(_component_q_checkbox, {
                            key: 0,
                            dense: "",
                            modelValue: data.selectAll,
                            "onUpdate:modelValue": [
                              _cache[1] || (_cache[1] = ($event: any) => ((data.selectAll) = $event)),
                              handleSelectAll
                            ]
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleColumns), (column, index) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: index,
                    class: _normalizeClass([{ sortable: column.sortable }, { sorted: column.sorted }]),
                    ref_for: true,
                    ref_key: "columnsRefs",
                    ref: columnsRefs,
                    "data-id": column.columnId
                  }, [
                    (column.sorted === 'asc')
                      ? (_openBlock(), _createBlock(_component_q_icon, {
                          key: 0,
                          name: "expand_more",
                          size: "sm"
                        }))
                      : _createCommentVNode("", true),
                    (column.sorted === 'desc')
                      ? (_openBlock(), _createBlock(_component_q_icon, {
                          key: 1,
                          name: "expand_less",
                          size: "sm"
                        }))
                      : _createCommentVNode("", true),
                    (column.filterable)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 2,
                          class: _normalizeClass({
                active: data.filters.find((filter) => filter.colName === column.name_column),
              }),
                          flat: "",
                          round: "",
                          size: "sm",
                          icon: "filter_alt"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(ColumnFilter, {
                                  initial: data.filters.find((filter) => filter.colName === column.name_column),
                                  multiple: column.filterable === _unref(FilterType).MULTIPLE,
                                  colName: column.name_column,
                                  items: setColumnValues(column.name_column),
                                  label: column.colname,
                                  onSetFilter: setColumnFilter,
                                  onRemoveFilter: removeColumnFilter
                                }, null, 8, ["initial", "multiple", "colName", "items", "label"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: "colname",
                      onClick: ($event: any) => (column.sortable ? sort(column) : '')
                    }, _toDisplayString(column.colname), 9, _hoisted_10),
                    (column.description)
                      ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 3 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(column.description), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_9))
                }), 128))
              ]),
              _: 1
            }),
            (trustedStructure.show_total)
              ? (_openBlock(), _createBlock(_component_q_tr, { key: 0 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleColumns), (_, index) => {
                      return (_openBlock(), _createBlock(_component_q_th, { key: index }, {
                        default: _withCtx(() => [
                          (_unref(visibleColumns)[index].data_type === 'money')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(sumFieldValues)(_unref(paginatedItems), _unref(visibleColumns)[index].name_column)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, _unref(showTableHeader)]
          ]),
          (data.items.length)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paginatedItems), (row, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_q_tr, {
                      class: _normalizeClass([
              { row_clickable: trustedStructure.expandable_rows
                  && (_unref(hiddenColumns).length || trustedStructure?.expandable_contents),
              },
              { expanded_top: row[data.field_id] === data.expandedRow },
            ]),
                      draggable: Boolean(trustedStructure.draggable),
                      onDragstart: ($event: any) => (onDragStart($event, row)),
                      onDragover: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (onDragOver($event)), ["prevent"])),
                      onDragleave: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (onDragLeave($event)), ["prevent"])),
                      onDragenter: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop","prevent"])),
                      onDrop: _withModifiers(($event: any) => (onDrop($event, row)), ["stop","prevent"]),
                      onClick: ($event: any) => (expandRow(row))
                    }, {
                      default: _withCtx(() => [
                        (trustedStructure.selection)
                          ? (_openBlock(), _createBlock(_component_q_td, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_checkbox, {
                                  dense: "",
                                  val: row[data.field_id],
                                  modelValue: data.selectedItems,
                                  "onUpdate:modelValue": [
                                    _cache[2] || (_cache[2] = ($event: any) => ((data.selectedItems) = $event)),
                                    handleSelect
                                  ]
                                }, null, 8, ["val", "modelValue"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleColumns), (_, index) => {
                          return (_openBlock(), _createBlock(_component_q_td, {
                            class: _normalizeClass(`table-cell-${_unref(visibleColumns)[index].content_type || 'default'}`),
                            key: index,
                            style: _normalizeStyle(row.style_row),
                            onMouseenter: ($event: any) => (showTooltip($event, row[_unref(visibleColumns)[index].name_column])),
                            onMouseleave: hideTooltip,
                            onFocusin: ($event: any) => (showTooltip($event, row[_unref(visibleColumns)[index].name_column])),
                            onFocusout: hideTooltip
                          }, {
                            default: _withCtx(() => [
                              _renderSlot(_ctx.$slots, "default", {}, () => [
                                _createElementVNode("div", _hoisted_13, [
                                  (_unref(visibleColumns)[index].content_type === 'json_string')
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 0,
                                        style: {"float":"left"},
                                        flat: "",
                                        round: "",
                                        icon: 
                      index === data.expandedJsonCell.col &&
                      row[data.field_id] === data.expandedJsonCell.row
                        ? 'remove'
                        : 'add'
                    ,
                                        color: "accent",
                                        onClick: ($event: any) => (jsonCellHandler(index, row[data.field_id]))
                                      }, null, 8, ["icon", "onClick"]))
                                    : _createCommentVNode("", true),
                                  (_unref(visibleColumns)[index].content_type === 'custom')
                                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(defineComponentName)(_unref(visibleColumns)[index])), _mergeProps({ key: 1 }, 
                      _unref(defineCellProps)(_unref(visibleColumns)[index], row[_unref(visibleColumns)[index].name_column])
                    , {
                                        actionParams: 
                      Object.assign(row, _unref(visibleColumns)[index]?.value?.action?.customParam)
                    ,
                                        field_id: trustedStructure.field_id,
                                        onAction: _unref(actionHandler)
                                      }), null, 16, ["actionParams", "field_id", "onAction"]))
                                    : _createCommentVNode("", true),
                                  (
                      !['json', 'custom'].includes(_unref(visibleColumns)[index].content_type) ||
                      (index === data.expandedJsonCell.col &&
                        row[data.field_id] === data.expandedJsonCell.row)
                    )
                                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(defineComponentName)(_unref(visibleColumns)[index])), _mergeProps({ key: 2 }, 
                      _unref(defineCellProps)(_unref(visibleColumns)[index], row[_unref(visibleColumns)[index].name_column])
                    , {
                                        style: [`width: ${_unref(visibleColumns)[index].width}px`],
                                        actionParams: 
                      Object.assign(row, _unref(visibleColumns)[index]?.value?.action?.customParam)
                    ,
                                        onAction: _unref(actionHandler)
                                      }), null, 16, ["style", "actionParams", "onAction"]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["class", "style", "onMouseenter", "onFocusin"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["class", "draggable", "onDragstart", "onDrop", "onClick"]),
                    (
              trustedStructure.expandable_rows
              && row[data.field_id] === data.expandedRow
              && (_unref(hiddenColumns).length || trustedStructure?.expandable_contents))
                      ? (_openBlock(), _createBlock(_component_q_tr, {
                          key: 0,
                          class: "expanded_bottom"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("td", { colspan: _unref(expandableAreaSize) }, [
                              _createVNode(ExpandableContent, {
                                data: row,
                                columns: _unref(hiddenColumns),
                                additional: trustedStructure?.expandable_contents,
                                onUnhideColumn: togglePin,
                                onRefresh: onRefresh
                              }, null, 8, ["data", "columns", "additional"])
                            ], 8, _hoisted_14)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_unref(emptyState))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(emptyStateText.value), 1))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["class"])), [
        [_unref(vResizeColumns), void 0, __props.tableId]
      ])
    ], 512),
    (_unref(items).length > 20 && trustedStructure.pagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_q_select, {
            outlined: "",
            dense: "",
            modelValue: data.itemsPerPage,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((data.itemsPerPage) = $event)),
            options: paginationOptions
          }, null, 8, ["modelValue"]),
          (trustedStructure.pagination)
            ? (_openBlock(), _createBlock(_component_q_pagination, {
                key: 0,
                max: _unref(maxPages),
                "max-pages": 5,
                color: "accent",
                "direction-links": "",
                "boundary-links": "",
                "boundary-numbers": "",
                modelValue: data.currentPage,
                "onUpdate:modelValue": [
                  _cache[7] || (_cache[7] = ($event: any) => ((data.currentPage) = $event)),
                  paginate
                ]
              }, null, 8, ["max", "modelValue"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (tooltip.value.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "global-tooltip",
          style: _normalizeStyle({
         left: `${tooltip.value.x}px`,
         top: `${tooltip.value.y}px`
       })
        }, _toDisplayString(tooltip.value.content), 5))
      : _createCommentVNode("", true)
  ], 64))
}
}

})